import React from "react";
import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import CloseIcon from '@mui/icons-material/Close';
import { blackcolor, darkcolor, whitecolor } from "../../../style2";


export default function PreviewRecordDialog({ open, handleClose, record }) {
  const endsWith = (source, target) => {
    return source.indexOf(target, source.length - target.length) !== -1;
  }

  if (record != null) {
    return (
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <Grid container sx={{ flexGrow:1, backgroundColor: darkcolor, color: whitecolor, padding: "10px" }}>
          <Grid item size={11} >
            <Typography>{record.displayName}</Typography>
          </Grid>
          <Grid item size={1} style={{ textAlign: "right", cursor: "pointer" }}>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
        {record.mime.indexOf("image/") > -1 ?
          <Grid style={{ backgroundColor: blackcolor, textAlign: "center", minHeight: "500px", maxHeight: "700px", overflowY: "auto" }}>
            <img src={record.s3TempPath} alt="" style={{ maxWidth: "100%", height: "auto", minHeight: "500px" }} />
          </Grid> : null}
        {record.mime.indexOf("audio/") > -1 ?
          <Grid style={{ backgroundColor: blackcolor, textAlign: "center", padding: "10px" }}>
            <audio controls src={record.s3TempPath} style={{ height: "50px", width: "100%" }}></audio>
          </Grid> : null}
        {record.mime.indexOf("video/") > -1 ?
          <Grid style={{ backgroundColor: blackcolor, textAlign: "center", padding: "10px", height: "600px" }}>
            <video controls src={record.s3TempPath} style={{ width: "100%", height: "99%" }}></video>
          </Grid> : null}
          {record.mime.indexOf("application/") > -1 && (endsWith(record.displayName, ".pdf")) ?
          <Grid style={{ backgroundColor: "transparent", textAlign: "center", height: "600px", paddingBottom: "5px" }}>
            <iframe src={record.s3TempPath} title="Record" style={{ width: "100%", height: "99%" }}></iframe>
          </Grid> : record.mime.indexOf("application/") > -1  ?
          <Grid style={{ backgroundColor: "transparent", textAlign: "center", height: "600px", paddingBottom: "5px" }}>
            <Box padding={10}>
              <Typography>Unable to display document here. <a href={record.s3TempPath}>Click to download</a></Typography>
            </Box>
          </Grid> : null} 
        

      </Dialog>
    );
  } else {
    return <></>;
  }
}
